import { useTranslate } from "hooks";
import React, { type JSX } from "react";
import * as Scrivito from "scrivito";
import { getPageLink } from "utils";

type FooterLinkedImageProps = { widget: Scrivito.Widget; className: string };

export const FooterLinkedImage = Scrivito.connect(
  ({ widget, className }: FooterLinkedImageProps) => {
    const translate = useTranslate();
    const title = widget.objClass() === "ImageFooterWidget" && (
      <Scrivito.ContentTag content={widget} attribute="title" tag="h5" />
    );

    const image = (
      <Scrivito.ImageTag
        content={widget}
        attribute="image"
        className="img-fluid mb-0"
        alt="footer_img"
        height="235"
      />
    );

    const text = widget.objClass() === "ImageFooterWidget" && (
      <Scrivito.ContentTag content={widget} attribute="text" />
    );

    const link = widget.get("link") as Scrivito.Link;

    let linkTitle = translate("TEXT_READ_MORE") as string | JSX.Element;

    if (link && link.title()) {
      linkTitle = link.title() as string;
    }
    if (link && link.isInternal()) {
      linkTitle = link?.obj()?.get("title") as string;
    }

    return (
      <aside className={className}>
        {title}
        <div className="mb-3">
          {link ? (
            <Scrivito.LinkTag to={getPageLink(link) as Scrivito.Link}>
              {image}
            </Scrivito.LinkTag>
          ) : (
            image
          )}
        </div>
        {text}
        {link && (
          <Scrivito.LinkTag
            to={getPageLink(link) as Scrivito.Link}
            className="button button-link"
          >
            {linkTitle}
          </Scrivito.LinkTag>
        )}
      </aside>
    );
  },
);
